<template>

  <FatturaVoci />
 
</template>

<script>
import FatturaVoci from '../components/ask/pages/FatturaVoci.vue'

export default {
  components: {
    FatturaVoci

  },
  data() {
    return {

    }
  },

  created(){
    
  },

  mounted(){
    this.$eventBus.emit('page-change', {
      target: this,
      currentRoute: this.$router.currentRoute.value
    })
  },

  methods: {
    
  },
}
</script>

